var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.d{fill:none;}.c,.f{fill:#484848;}.d{stroke:#ededed;stroke-linecap:round;}.e,.f{stroke:none;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    rx: 7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-600 -399)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(607.65 402.891)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,0H8.668L11,2.552V14H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 1 1 L 1 13 L 10 13 L 10 2.940425872802734 L 8.227386474609375 1 L 1 1 M 0 0 L 8.668310165405273 0 L 11 2.552430152893066 L 11 14 L 0 14 L 0 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H8.668L11,2.552V14H0Z",
    transform: "translate(606 404.275)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x2: 6,
    transform: "translate(608.5 409.127)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x2: 6,
    transform: "translate(608.5 411.021)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x2: 6,
    transform: "translate(608.5 412.775)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.27272d8e3d34c627ab1c5041f22d0233.svg";
export { ForwardRef as ReactComponent };